export default __webpack_public_path__ + "static/media/GLOSSARY.f537cc5f.pdf";